<template>
  <el-card :bordered="false" shadow="never">
    <div class="logo">
      <img src="./images/logo.png" alt="logo" />
    </div>
    <div class="title">
      <div class="left">
        <img src="./images/img2.png" alt="img" />
      </div>
      <div class="content">
        <h3>BRAZIL</h3>
        <p>At A Glance:</p>
        <p>
          2022 Projected Real GDP (% Change) :
          <span>0.8</span>
        </p>
        <p>
          2022 Projected Consumer Prices (% Change):
          <span>8.2</span>
        </p>
        <p>
          Country Population:
          <span>213.911 million</span>
        </p>
      </div>
    </div>
    <div class="img-list">
      <img src="./images/img1.png" alt="img" />
      <img src="./images/img3.png" alt="img" />
      <img src="./images/img4.png" alt="img" />
      <img src="./images/img5.png" alt="img" />
    </div>
    <div class="introduce">
      <h2>Pros:</h2>
      <ul>
        <li>
          1. Large international reserves, low external debt, proactive monetary
          policy, floating exchange rate, and favorable sovereign debt
          composition constitute relative credit strengths that provide key
          resiliency that should enable it to address the challenging and
          volatile global environment.
        </li>
        <li>
          2. Improved policy effectiveness will support economic performance and
          fiscal consolidation post crisis (approval of pension reform resulted
          in total savings of BRL 800 billion).
        </li>
        <li>
          3. While the increase in Brazil's fiscal deficits will put pressure on
          the domestic markets, the Treasury's cash buffers, and proactive
          liability management efforts should help it navigate this period of
          higher investor risk aversion.
        </li>
        <li>
          4. Brazil's ratings are supported by its large and diverse economy,
          high per capita income relative to peers and capacity to absorb
          external shocks underpinned by its flexible exchange rate, moderate
          external imbalances, robust international reserves and deep domestic
          government debt market.
        </li>
      </ul>
    </div>
    <div class="introduce">
      <h2>Cons:</h2>
      <ul>
        <li>
          1. Large international reserves, low external debt, proactive monetary
          policy, floating exchange rate, and favorable sovereign debt
          composition constitute relative credit strengths that provide key
          resiliency that should enable it to address the challenging and
          volatile global environment.
        </li>
        <li>
          2. The impact of containment measures, lower investor confidence, and
          financial market volatility will likely constrain consumption and
          investment.
        </li>
        <li>
          3. Heavy presence of the government-owned banks, causing market
          distortions.
        </li>
        <li>4. Weaker payment culture than in developed economies.</li>
      </ul>
    </div>
    <div class="img-list">
      <img src="./images/img6.png" alt="img" />
      <img src="./images/img7.png" alt="img" />
      <img src="./images/img8.png" alt="img" />
    </div>
  </el-card>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.logo {
  padding-top: 20px;
  text-align: right;
}

.title {
  display: flex;

  .left {
    margin-right: 20px;
  }

  .content {
    h3 {
      font-size: 16px;
      color: #3a3f63;
      line-height: 24px;
      font-weight: bold;
      margin-bottom: 13px;
    }

    p {
      font-size: 14px;
      color: #3a3f63;
      line-height: 24px;

      span {
        font-weight: bold;
        color: #ffb243;
      }
    }
  }
}

.img-list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 30px;

  img {
    margin-bottom: 20px;
  }
}

.introduce {
  margin-top: 30px;
  h2 {
    font-weight: bold;
    color: #2b2f42;
    line-height: 16px;
    margin-bottom: 20px;
  }

  li {
    font-size: 14px;
    color: #3a3f63;
    line-height: 24px;
  }
}
</style>
